<template>
  <div id="app" class="app">
    <!-- 全屏显示 -->
    <keep-alive :include="includeList">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
import Cookies from 'js-cookie';
import { mapState } from 'vuex';
import apis from '@/utils/apis';
import locale from '@/locales/locale.json';

export default {
  name: 'App',
  data() {
    return {
      isLoaded: false, // 是否已加载全局多语言
      langComp: {}, // 已加载的组件多语言
      dictionary: {}, // 已加载数据字典
    };
  },
  watch: {
    $route: function () {
      // bug描述： 点击跳转新页面时，el-tooltip如果是显示的话，不会消失
      const els = document.querySelectorAll('.el-tooltip__popper');
      [...els].forEach((el) => {
        el.style.display = 'none';
      });
    },
  },
  computed: {
    ...mapState({
      includeList: state => state.vm.includeList,
    }),
  },
  mounted() {
    this.getLoginLanguage();
    const getDictionaryDebounce = this.mergeDebounce(this.getDictionary1);
    const getFuncViewDebounce = this.mergeDebounce(this.getFuncView1);
    this.Bus.$on('getDictionary', getDictionaryDebounce);
    this.Bus.$on('getFuncView', getFuncViewDebounce);
    this.Bus.$on('asyncLanguage', this.asyncLanguage1);
  },
  methods: {
    getLoginLanguage() {
      this.$getJSON(apis.LanguageLogin, { appCode: 'customer-portal', langKeyCode: 'bind_account,find_password,reset_password,login' }).then((res) => {
        const langCode = Cookies.get('langCode') || 'CN';
        this.$i18n.mergeLocaleMessage(langCode, res.data);
      });
    },
    // 等待执行
    sleep: async function (time) {
      return new Promise((resolve) => {
        setInterval(() => {
          resolve();
        }, time);
      });
    },
    // 获取指定key新对象
    getFormatData: (data, str) => {
      const keys = str.split(',');
      const todata = {};
      keys.forEach((t) => {
        todata[t] = typeof data[t] === 'undefined' ? null : data[t];
      });
      return todata;
    },
    // 多语言、字典防抖
    mergeDebounce(fn, delay = 200) {
      let timer;
      let argsList;
      return function (...args) {
        if (timer) {
          argsList.push(args);
          clearTimeout(timer);
        } else {
          argsList = [args];
        }
        timer = setTimeout(() => {
          args[args.length] = argsList;
          fn.apply(this, args);
          timer = null;
        }, delay);
      };
    },
    // 获取功能
    getFuncView1(loadRes, cb, argsList) {
      const cache = this.$store.state.funcView;
      if (cache[loadRes]) {
        argsList.forEach((item) => {
          const fn = item[1] || function () {};
          fn(cache[loadRes]);
        });
        return;
      }
      this.$getJSON(apis.FuncView, { loadRes: loadRes }).then((res) => {
        this.$store.commit('FUNCVIEW', Object.assign(cache, { [loadRes]: res.data }));
        argsList.forEach((item) => {
          const fn = item[1] || function () {};
          fn(res.data);
        });
      });
    },
    // 获取字典
    getDictionary1(codes, cb, argsList) {
      const list = argsList
        .map(t => t[0])
        .join(',')
        .split(',');
      const codeList = [...new Set(list)];
      const diffCodes = codeList.filter(t => !Object.keys(this.dictionary).includes(t));
      if (diffCodes.length === 0) {
        argsList.forEach((item) => {
          const params = this.getFormatData(this.dictionary, item[0]);
          const fn = item[1] || function () {};
          fn(params);
        });
        return;
      }
      this.$getJSON(apis.DictionaryCode, {
        groupCodes: diffCodes.join(','),
      }).then((res) => {
        this.dictionary = Object.assign(this.dictionary, res.data || {});
        argsList.forEach((item) => {
          const params = this.getFormatData(this.dictionary, item[0]);
          const fn = item[1] || function () {};
          fn(params);
        });
      });
    },
    // 同步多语言
    asyncLanguage1: async function () {
      if (process.env.NODE_ENV !== 'development') {
        return;
      }
      const groupCodes = Object.keys(locale);
      /* eslint-disable */
      console.warn('------  多语言同步开始  --------');
      for (let i = 0; i <= groupCodes.length - 1; i++) {
        await this.sleep(300);
        const groupCode = groupCodes[i];
        /* eslint-disable */
        console.warn(`《${groupCode}》多语言同步中....`);
        // EN: enLocale[groupCode], TW: twLocale[groupCode]
        const langKey = locale[groupCode];
        delete langKey.__filePath;
        await this.$postJSON(apis.LanguageSyncCompApp, { appCode: 'customer-portal', groupCode, langKey, langData: { EN: undefined, TW: undefined } });
        /* eslint-disable */
        console.warn(`《${groupCode}》完成`);
      }
      /* eslint-disable */
      console.warn('------  多语言同步结束  --------');
    },
  },
};
</script>

<style lang="scss">
@import './style/base.css';
/*@import "./style/iconfont.css";*/
</style>
